import { IconProps } from './index';

const DeclinedVideoCamera = ({
    title,
    titleId,
    ...props
}: React.SVGProps<SVGSVGElement> & IconProps) => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            {title && <title id={titleId}>{title}</title>}
            <path
                d="M17 10.5V7C17 6.45 16.55 6 16 6H4C3.45 6 3 6.45 3 7V17C3 17.55 3.45 18 4 18H16C16.55 18 17 17.55 17 17V13.5L19.29 15.79C19.92 16.42 21 15.97 21 15.08V8.91C21 8.02 19.92 7.57 19.29 8.2L17 10.5Z"
                fill="#ED434B"
            />
            <path
                d="M10.0004 11.2932L12.4754 8.81818L13.1824 9.52518L10.7074 12.0002L13.1824 14.4752L12.4754 15.1822L10.0004 12.7072L7.52536 15.1822L6.81836 14.4752L9.29336 12.0002L6.81836 9.52518L7.52536 8.81818L10.0004 11.2932Z"
                fill="white"
            />
        </svg>
    );
};

export default DeclinedVideoCamera;
